package com.example.positionahead.domain

import com.example.positionahead.model.AlertType
import com.example.positionahead.model.PositionSnapshot
import com.example.positionahead.model.PriceAlert
import com.example.positionahead.model.Quote
import kotlinx.datetime.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

object AlertEvaluator {

    fun evaluate(
        alerts: List<PriceAlert>,
        quotes: Map<String, Quote>,
        positions: List<PositionSnapshot>,
    ): List<PriceAlert> {
        val now = currentTimestamp()
        return alerts.map { alert ->
            if (!alert.enabled || alert.triggeredAt != null) return@map alert
            if (isTriggered(alert, quotes, positions)) {
                alert.copy(triggeredAt = now, read = false)
            } else {
                alert
            }
        }
    }

    fun describe(alert: PriceAlert): String = when (alert.type) {
        AlertType.PRICE_ABOVE -> "${alert.symbol} rises above ${formatThreshold(alert.threshold)}"
        AlertType.PRICE_BELOW -> "${alert.symbol} falls below ${formatThreshold(alert.threshold)}"
        AlertType.GAIN_ABOVE_PCT -> "${alert.symbol} gain exceeds +${alert.threshold}% vs purchase"
        AlertType.LOSS_BELOW_PCT -> "${alert.symbol} loss exceeds -${alert.threshold}% vs purchase"
    }

    private fun isTriggered(
        alert: PriceAlert,
        quotes: Map<String, Quote>,
        positions: List<PositionSnapshot>,
    ): Boolean {
        val symbol = alert.symbol.uppercase()
        return when (alert.type) {
            AlertType.PRICE_ABOVE -> quotes[symbol]?.price?.let { it >= alert.threshold } == true
            AlertType.PRICE_BELOW -> quotes[symbol]?.price?.let { it <= alert.threshold } == true
            AlertType.GAIN_ABOVE_PCT -> positions
                .find { it.position.symbol.uppercase() == symbol }
                ?.unrealizedGainLossPercent
                ?.let { it >= alert.threshold } == true
            AlertType.LOSS_BELOW_PCT -> positions
                .find { it.position.symbol.uppercase() == symbol }
                ?.unrealizedGainLossPercent
                ?.let { it <= -alert.threshold } == true
        }
    }

    private fun formatThreshold(value: Double): String =
        if (value >= 100) "$${kotlin.math.round(value * 100) / 100}" else value.toString()

    @OptIn(ExperimentalTime::class)
    private fun currentTimestamp(): String =
        Instant.fromEpochMilliseconds(Clock.System.now().toEpochMilliseconds())
            .toLocalDateTime(TimeZone.currentSystemDefault())
            .toString()
}
